export const ADDRESS_LIST_LENGTH = 30
export const CITY_LIST_LENGTH = 200
